import { render, staticRenderFns } from "./speech.vue?vue&type=template&id=4eab79a8"
import script from "./speech.vue?vue&type=script&lang=js"
export * from "./speech.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports